import React from "react"
import types from "prop-types"
import clsx from "clsx"
import * as StatusListHelpers from "utils/statusListHelpers"
import { submissionStatusShape } from "utils/propTypeShapes"
import ItemRow from "shared/ItemRow"
import { TextInput } from "shared/inputs"
import { CircularIconButton } from "shared/buttons"

const SubmissionStatus = ({
  savedStatus = undefined,
  status,
  updateName,
  handle = undefined,
  isDiscardable = false,
  discardStatus = () => {},
}) => (
  <ItemRow
    className="dark"
    itemRowHeaderContent={(
      <>
        <div className="flex flex-row items-center gap-4 grow">
          {
            handle && (<span>{handle}</span>)
          }
          <span className="grow">{savedStatus?.name}</span>
        </div>
        <div className={clsx(!isDiscardable && "lg:!w-[14.25rem]", "w-full lg:w-44")}>
          <TextInput
            className="bordered-base-input !text-sm !bg-white"
            value={status.name}
            onChange={updateName}
            isStatusValid={StatusListHelpers.isStatusValid(status)}
            errorMessages={StatusListHelpers.statusErrorMessages(status)}
          />
        </div>
      </>
    )}
    itemRowHeaderControls={(
      <>
        {
          isDiscardable && (
            <CircularIconButton
              ariaLabel="delete submission status"
              icon="close"
              onClick={discardStatus}
            />
          )
        }
      </>
    )}
  />
)

SubmissionStatus.propTypes = {
  savedStatus: submissionStatusShape,
  status: submissionStatusShape.isRequired,
  updateName: types.func.isRequired,
  handle: types.node,
  isDiscardable: types.bool,
  discardStatus: types.func,
}

export default SubmissionStatus
